import type { components } from "#open-fetch-schemas/atlit";

const LEAGUE_TYPE_ASSOCIATION = "association";
const LEAGUE_TYPE_CLASS = "class";
const LEAGUE_TYPE_DIVISION = "division";
const LEAGUE_TYPE_TOURNAMENT = "tournament";
const LEAGUE_TYPE_GROUP = "group";
const LEAGUE_TYPE_OTHER = "other";

export const LEAGUE_TYPE = {
  ASSOCIATION: LEAGUE_TYPE_ASSOCIATION,
  CLASS: LEAGUE_TYPE_CLASS,
  DIVISION: LEAGUE_TYPE_DIVISION,
  TOURNAMENT: LEAGUE_TYPE_TOURNAMENT,
  GROUP: LEAGUE_TYPE_GROUP,
  OTHER: LEAGUE_TYPE_OTHER,
} as const;

/**
 * List of league types that have stats tabs
 *
 * Leagues with such types would have "Standings" and "Leaderboards" tabs in the UI
 */
export const LEAGUE_TYPE_WITH_STATS_TABS: components["schemas"]["LeagueType"][] = [
  LEAGUE_TYPE.ASSOCIATION,
  LEAGUE_TYPE.CLASS,
  LEAGUE_TYPE.DIVISION,
  LEAGUE_TYPE.TOURNAMENT,
  LEAGUE_TYPE.GROUP,
];
